import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.initializeSelectize()
  }

  disconnect() {
    if (this.selectize) {
      this.selectize.destroy()
    }
  }

  initializeSelectize() {
    if (typeof $ !== 'undefined' && this.hasSelectTarget) {
      $(this.selectTarget).selectize({
        maxItems: 1,
        sortField: "text",
        create: false,
      })

      this.selectize = this.selectTarget.selectize
    }
  }
}
